import React from 'react';
import PropTypes from 'prop-types';
import style from './BrandLogo.module.scss';

const BrandLogo = (props) => {

  let {
    name,
    imageUrl,
    pageUrl,
  } = props;

  return (
    <React.Fragment>
      <div className="sq-frame mr-3">
        <img className="img-fluid" id="previewCatalogCompanyLogo" src={imageUrl} />
      </div>
      <a href={pageUrl}>
        <span className="cap" id="previewCatalogCompanyName">{name}</span>
      </a>
    </React.Fragment>

    // <div className={style.BrandLogo}>
    //   <img className={style.img} src={imageUrl} />
    //   <div className={style.name}>{name}</div>
    // </div>
  )

};

BrandLogo.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default BrandLogo;
